const styleId = 'icf-easter-egg-glow-style'

// Styles are injected from JS on purpose: PurgeCSS only scans
// php/html/jsx/tsx sources, so classes referenced solely in this .ts file
// would be purged from the compiled stylesheets.
// The effect is a pure opacity fade on a static gradient - no movement or
// scaling - so it is safe under prefers-reduced-motion by design.
const css = `
.icf-easter-egg-glow {
  position: fixed;
  inset: 0;
  z-index: 9999;
  pointer-events: none;
  opacity: 0;
  background: radial-gradient(
    ellipse 120% 70% at 50% -10%,
    var(--icf-egg-glow-color),
    transparent 70%
  );
  animation: icf-easter-egg-glow var(--icf-egg-glow-duration) ease-in-out forwards;
}

@keyframes icf-easter-egg-glow {
  0% { opacity: 0; }
  30% { opacity: 0.9; }
  70% { opacity: 0.9; }
  100% { opacity: 0; }
}
`

function injectStyles() {
  if (document.getElementById(styleId)) return
  const style = document.createElement('style')
  style.id = styleId
  style.textContent = css
  document.head.appendChild(style)
}

export function playGlow(options: { color?: string; durationMs?: number }) {
  const { color = '#ffd27a', durationMs = 3000 } = options
  injectStyles()

  const overlay = document.createElement('div')
  overlay.className = 'icf-easter-egg-glow'
  overlay.setAttribute('aria-hidden', 'true')
  overlay.style.setProperty('--icf-egg-glow-color', color)
  overlay.style.setProperty('--icf-egg-glow-duration', `${durationMs}ms`)
  overlay.addEventListener('animationend', () => overlay.remove())
  // fallback in case the animation never fires (e.g. hidden tab)
  setTimeout(() => overlay.remove(), durationMs + 500)

  document.body.appendChild(overlay)
}
